/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadsBulkRequestDocumentsInner
 */
export interface CreateLeadsBulkRequestDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequestDocumentsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequestDocumentsInner
     */
    s3_key: string;
}

/**
 * Check if a given object implements the CreateLeadsBulkRequestDocumentsInner interface.
 */
export function instanceOfCreateLeadsBulkRequestDocumentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function CreateLeadsBulkRequestDocumentsInnerFromJSON(json: any): CreateLeadsBulkRequestDocumentsInner {
    return CreateLeadsBulkRequestDocumentsInnerFromJSONTyped(json, false);
}

export function CreateLeadsBulkRequestDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadsBulkRequestDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function CreateLeadsBulkRequestDocumentsInnerToJSON(value?: CreateLeadsBulkRequestDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        's3_key': value.s3_key,
    };
}

